/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddOrganizationTrialRowRequest } from "../models/AddOrganizationTrialRowRequest";
import type { Body_OrganizationProject_create_organization_trial } from "../models/Body_OrganizationProject_create_organization_trial";
import type { Body_OrganizationProject_upload_organization_product_documents } from "../models/Body_OrganizationProject_upload_organization_product_documents";
import type { Body_OrganizationProject_upload_trial_documents } from "../models/Body_OrganizationProject_upload_trial_documents";
import type { BooleanResponse } from "../models/BooleanResponse";
import type { CreateOrganizationProductRequest } from "../models/CreateOrganizationProductRequest";
import type { CreateOrganizationProjectProductTrialRequest } from "../models/CreateOrganizationProjectProductTrialRequest";
import type { CreateOrganizationProjectRequest } from "../models/CreateOrganizationProjectRequest";
import type { PaginatedResponse_list_definitions_public_v1_organization_project_OrganizationProjectListing__ } from "../models/PaginatedResponse_list_definitions_public_v1_organization_project_OrganizationProjectListing__";
import type { Response_CreateOrganizationProjectProductTrialResult_ } from "../models/Response_CreateOrganizationProjectProductTrialResult_";
import type { Response_OrganizationProduct_ } from "../models/Response_OrganizationProduct_";
import type { Response_OrganizationProject_ } from "../models/Response_OrganizationProject_";
import type { Response_OrganizationTrialRegulatoryRun_ } from "../models/Response_OrganizationTrialRegulatoryRun_";
import type { Response_ProductAndTrialID_ } from "../models/Response_ProductAndTrialID_";
import type { Response_Trial_ } from "../models/Response_Trial_";
import type { Response_UUID_ } from "../models/Response_UUID_";
import type { RunOrganizationTrialRegulatoryCheckRequest } from "../models/RunOrganizationTrialRegulatoryCheckRequest";
import type { UpdateOrganizationProductRequest } from "../models/UpdateOrganizationProductRequest";
import type { UpdateOrganizationProjectRequest } from "../models/UpdateOrganizationProjectRequest";
import type { UpdateOrganizationTrialRequest } from "../models/UpdateOrganizationTrialRequest";
import type { UpdateOrganizationTrialRowRequest } from "../models/UpdateOrganizationTrialRowRequest";
import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";
export class OrganizationProjectService {
  /**
   * List Organization Projects
   * @param organizationId
   * @param qs A case insensitive name to search for.
   * @param limit The number of items to return.
   * @param offset The number of items to skip.
   * @returns PaginatedResponse_list_definitions_public_v1_organization_project_OrganizationProjectListing__ Successful Response
   * @throws ApiError
   */
  public static organizationProjectListOrganizationProjects(
    organizationId: string,
    qs?: string,
    limit: number = 50,
    offset?: number
  ): CancelablePromise<PaginatedResponse_list_definitions_public_v1_organization_project_OrganizationProjectListing__> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/organization/{organization_id}/projects",
      path: {
        organization_id: organizationId,
      },
      query: {
        qs: qs,
        limit: limit,
        offset: offset,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Create Organization Project
   * @param organizationId
   * @param requestBody
   * @returns Response_UUID_ Successful Response
   * @throws ApiError
   */
  public static organizationProjectCreateOrganizationProject(
    organizationId: string,
    requestBody: CreateOrganizationProjectRequest
  ): CancelablePromise<Response_UUID_> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/organization/{organization_id}/projects",
      path: {
        organization_id: organizationId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Create Structure From Product Brief
   * @param organizationId
   * @param requestBody
   * @returns Response_CreateOrganizationProjectProductTrialResult_ Successful Response
   * @throws ApiError
   */
  public static organizationProjectCreateStructureFromProductBrief(
    organizationId: string,
    requestBody: CreateOrganizationProjectProductTrialRequest
  ): CancelablePromise<Response_CreateOrganizationProjectProductTrialResult_> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/organization/{organization_id}/projects/batch",
      path: {
        organization_id: organizationId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Organization Project
   * @param organizationId
   * @param projectId
   * @returns Response_OrganizationProject_ Successful Response
   * @throws ApiError
   */
  public static organizationProjectGetOrganizationProject(
    organizationId: string,
    projectId: string
  ): CancelablePromise<Response_OrganizationProject_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/organization/{organization_id}/projects/{project_id}",
      path: {
        organization_id: organizationId,
        project_id: projectId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Organization Project
   * @param organizationId
   * @param projectId
   * @param requestBody
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static organizationProjectUpdateOrganizationProject(
    organizationId: string,
    projectId: string,
    requestBody: UpdateOrganizationProjectRequest
  ): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/organization/{organization_id}/projects/{project_id}",
      path: {
        organization_id: organizationId,
        project_id: projectId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Create Organization Product
   * @param organizationId
   * @param projectId
   * @param requestBody
   * @returns Response_ProductAndTrialID_ Successful Response
   * @throws ApiError
   */
  public static organizationProjectCreateOrganizationProduct(
    organizationId: string,
    projectId: string,
    requestBody: CreateOrganizationProductRequest
  ): CancelablePromise<Response_ProductAndTrialID_> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/organization/{organization_id}/projects/{project_id}/products",
      path: {
        organization_id: organizationId,
        project_id: projectId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Organization Product
   * @param organizationId
   * @param projectId
   * @param productId
   * @returns Response_OrganizationProduct_ Successful Response
   * @throws ApiError
   */
  public static organizationProjectGetOrganizationProduct(
    organizationId: string,
    projectId: string,
    productId: string
  ): CancelablePromise<Response_OrganizationProduct_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/organization/{organization_id}/projects/{project_id}/products/{product_id}",
      path: {
        organization_id: organizationId,
        project_id: projectId,
        product_id: productId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Organization Product
   * @param organizationId
   * @param projectId
   * @param productId
   * @param requestBody
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static organizationProjectUpdateOrganizationProduct(
    organizationId: string,
    projectId: string,
    productId: string,
    requestBody: UpdateOrganizationProductRequest
  ): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/organization/{organization_id}/projects/{project_id}/products/{product_id}",
      path: {
        organization_id: organizationId,
        project_id: projectId,
        product_id: productId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Upload Organization Product Documents
   * @param organizationId
   * @param projectId
   * @param productId
   * @param formData
   * @returns any Successful Response
   * @throws ApiError
   */
  public static organizationProjectUploadOrganizationProductDocuments(
    organizationId: string,
    projectId: string,
    productId: string,
    formData: Body_OrganizationProject_upload_organization_product_documents
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/organization/{organization_id}/projects/{project_id}/products/{product_id}/documents",
      path: {
        organization_id: organizationId,
        project_id: projectId,
        product_id: productId,
      },
      formData: formData,
      mediaType: "multipart/form-data",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Create Organization Trial
   * @param organizationId
   * @param projectId
   * @param productId
   * @param copy The trial to copy. If provided, the new trial will have its content populated from the source trial.
   * @param formData
   * @returns Response_UUID_ Successful Response
   * @throws ApiError
   */
  public static organizationProjectCreateOrganizationTrial(
    organizationId: string,
    projectId: string,
    productId: string,
    copy?: string,
    formData?: Body_OrganizationProject_create_organization_trial
  ): CancelablePromise<Response_UUID_> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/organization/{organization_id}/projects/{project_id}/products/{product_id}/trials",
      path: {
        organization_id: organizationId,
        project_id: projectId,
        product_id: productId,
      },
      query: {
        copy: copy,
      },
      formData: formData,
      mediaType: "multipart/form-data",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Trial
   * @param organizationId
   * @param projectId
   * @param productId
   * @param trialId
   * @returns Response_Trial_ Successful Response
   * @throws ApiError
   */
  public static organizationProjectGetTrial(
    organizationId: string,
    projectId: string,
    productId: string,
    trialId: string
  ): CancelablePromise<Response_Trial_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/organization/{organization_id}/projects/{project_id}/products/{product_id}/trials/{trial_id}",
      path: {
        organization_id: organizationId,
        project_id: projectId,
        product_id: productId,
        trial_id: trialId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Trial
   * @param organizationId
   * @param projectId
   * @param productId
   * @param trialId
   * @param requestBody
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static organizationProjectUpdateTrial(
    organizationId: string,
    projectId: string,
    productId: string,
    trialId: string,
    requestBody: UpdateOrganizationTrialRequest
  ): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/organization/{organization_id}/projects/{project_id}/products/{product_id}/trials/{trial_id}",
      path: {
        organization_id: organizationId,
        project_id: projectId,
        product_id: productId,
        trial_id: trialId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Upload Trial Documents
   * @param organizationId
   * @param projectId
   * @param productId
   * @param trialId
   * @param formData
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static organizationProjectUploadTrialDocuments(
    organizationId: string,
    projectId: string,
    productId: string,
    trialId: string,
    formData: Body_OrganizationProject_upload_trial_documents
  ): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/organization/{organization_id}/projects/{project_id}/products/{product_id}/trials/{trial_id}/documents",
      path: {
        organization_id: organizationId,
        project_id: projectId,
        product_id: productId,
        trial_id: trialId,
      },
      formData: formData,
      mediaType: "multipart/form-data",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Run Trial Regulatory Check
   * @param organizationId
   * @param projectId
   * @param productId
   * @param trialId
   * @param requestBody
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static organizationProjectRunTrialRegulatoryCheck(
    organizationId: string,
    projectId: string,
    productId: string,
    trialId: string,
    requestBody: RunOrganizationTrialRegulatoryCheckRequest
  ): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/organization/{organization_id}/projects/{project_id}/products/{product_id}/trials/{trial_id}/regulatory-run",
      path: {
        organization_id: organizationId,
        project_id: projectId,
        product_id: productId,
        trial_id: trialId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Trial Regulatory Run
   * @param organizationId
   * @param projectId
   * @param productId
   * @param trialId
   * @param regulatoryRunId
   * @returns Response_OrganizationTrialRegulatoryRun_ Successful Response
   * @throws ApiError
   */
  public static organizationProjectGetTrialRegulatoryRun(
    organizationId: string,
    projectId: string,
    productId: string,
    trialId: string,
    regulatoryRunId: string
  ): CancelablePromise<Response_OrganizationTrialRegulatoryRun_> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/organization/{organization_id}/projects/{project_id}/products/{product_id}/trials/{trial_id}/regulatory-run/{regulatory_run_id}",
      path: {
        organization_id: organizationId,
        project_id: projectId,
        product_id: productId,
        trial_id: trialId,
        regulatory_run_id: regulatoryRunId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Generate Qq Report
   * @param organizationId
   * @param projectId
   * @param productId
   * @param trialId
   * @returns any Successful Response
   * @throws ApiError
   */
  public static organizationProjectGenerateQqReport(
    organizationId: string,
    projectId: string,
    productId: string,
    trialId: string
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/organization/{organization_id}/projects/{project_id}/products/{product_id}/trials/{trial_id}/quantitative-report",
      path: {
        organization_id: organizationId,
        project_id: projectId,
        product_id: productId,
        trial_id: trialId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Generate Batch Sheet
   * @param organizationId
   * @param projectId
   * @param productId
   * @param trialId
   * @returns any Successful Response
   * @throws ApiError
   */
  public static organizationProjectGenerateBatchSheet(
    organizationId: string,
    projectId: string,
    productId: string,
    trialId: string
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/organization/{organization_id}/projects/{project_id}/products/{product_id}/trials/{trial_id}/batch-sheet",
      path: {
        organization_id: organizationId,
        project_id: projectId,
        product_id: productId,
        trial_id: trialId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Generate Ingredient List
   * @param organizationId
   * @param projectId
   * @param productId
   * @param trialId
   * @returns any Successful Response
   * @throws ApiError
   */
  public static organizationProjectGenerateIngredientList(
    organizationId: string,
    projectId: string,
    productId: string,
    trialId: string
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/organization/{organization_id}/projects/{project_id}/products/{product_id}/trials/{trial_id}/ingredient-list",
      path: {
        organization_id: organizationId,
        project_id: projectId,
        product_id: productId,
        trial_id: trialId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Create Trial Row
   * @param organizationId
   * @param projectId
   * @param productId
   * @param trialId
   * @param requestBody
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static organizationProjectCreateTrialRow(
    organizationId: string,
    projectId: string,
    productId: string,
    trialId: string,
    requestBody: AddOrganizationTrialRowRequest
  ): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/organization/{organization_id}/projects/{project_id}/products/{product_id}/trials/{trial_id}/rows",
      path: {
        organization_id: organizationId,
        project_id: projectId,
        product_id: productId,
        trial_id: trialId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Trial Rows
   * @param organizationId
   * @param projectId
   * @param productId
   * @param trialId
   * @param requestBody
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static organizationProjectUpdateTrialRows(
    organizationId: string,
    projectId: string,
    productId: string,
    trialId: string,
    requestBody: UpdateOrganizationTrialRowRequest
  ): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "PATCH",
      url: "/organization/{organization_id}/projects/{project_id}/products/{product_id}/trials/{trial_id}/rows",
      path: {
        organization_id: organizationId,
        project_id: projectId,
        product_id: productId,
        trial_id: trialId,
      },
      body: requestBody,
      mediaType: "application/json",
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Delete Trial Row
   * @param organizationId
   * @param projectId
   * @param productId
   * @param trialId
   * @param rowId
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static organizationProjectDeleteTrialRow(
    organizationId: string,
    projectId: string,
    productId: string,
    trialId: string,
    rowId: string
  ): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/organization/{organization_id}/projects/{project_id}/products/{product_id}/trials/{trial_id}/rows/{row_id}",
      path: {
        organization_id: organizationId,
        project_id: projectId,
        product_id: productId,
        trial_id: trialId,
        row_id: rowId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Generate Organization Trial Regulatory Report
   * @param organizationId
   * @param projectId
   * @param productId
   * @param trialId
   * @param regulatoryRunId
   * @returns BooleanResponse Successful Response
   * @throws ApiError
   */
  public static organizationProjectGenerateOrganizationTrialRegulatoryReport(
    organizationId: string,
    projectId: string,
    productId: string,
    trialId: string,
    regulatoryRunId: string
  ): CancelablePromise<BooleanResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/organization/{organization_id}/projects/{project_id}/products/{product_id}/trials/{trial_id}/regulatory-run/{regulatory_run_id}/report",
      path: {
        organization_id: organizationId,
        project_id: projectId,
        product_id: productId,
        trial_id: trialId,
        regulatory_run_id: regulatoryRunId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Organization Trial Regulatory Run Progress
   * @param organizationId
   * @param projectId
   * @param productId
   * @param trialId
   * @param regulatoryRunId
   * @returns any Successful Response
   * @throws ApiError
   */
  public static organizationProjectGetOrganizationTrialRegulatoryRunProgress(
    organizationId: string,
    projectId: string,
    productId: string,
    trialId: string,
    regulatoryRunId: string
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/organization/{organization_id}/projects/{project_id}/products/{product_id}/trials/{trial_id}/regulatory-run/{regulatory_run_id}/progress",
      path: {
        organization_id: organizationId,
        project_id: projectId,
        product_id: productId,
        trial_id: trialId,
        regulatory_run_id: regulatoryRunId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
